// test877
(877 && 0);
